import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor

function Close(props) {
  const [isEdit, setisEdit] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [isValidDoc, setisValidDoc] = useState(false);
  const dispatch = useDispatch();
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [pinCodeDetails, setPinCodeDetails] = useState(null);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bankVerfiyJson, setBankVerfiyJson] = useState("");
  const [bankVerificationDone, setBankVerificationDone] = useState(false);
  const [banks, setBanks] = useState([]);
  const [securityChequeImages, setSecurityChequeImages] = useState([]);
  const [isSalesPersonsValid, setIsSalesPersonsValid] = useState(true);
  const [isZonesValid, setIsZonesValid] = useState(true);
  const [isTradeVaild, setIsTradeVaild] = useState(true);

  let isAvailableImgAppended = false;
  const [verifiedBankDetails, setVerifiedBankDetails] = useState({
    accountNumber: "",
    ifscCode: "",
  });
  const [bankErrors, setBankErrors] = useState({
    accountNumber: "",
    ifscCode: "",
    bankName: "",
  });

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    companyName: "",
    courierName: "",
    docketNo: "",
    contactPerson: "",
    courierAddress: "",
    code: "Auto Generated", // Auto-generated field
    zones: [],
    gstNumber: "",
    authPersonName: "",
    creditLimit: "",
    designation: "",
    return_date: "",
    tradeOrNonTrade: [],
    deposit_date: "",
    deposit_amount: "",
    cheque_date: "",
    salesPersons: [],
    paymentType: "",
    customPaymentTerm: "",
    termsAndConditions: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    image: [],
    remark: "",
    amount: "",
    branch: "",
  });
  const codeLabelMap = {
    distributor: "Distributor Code",
    dealer: "Dealer Code",
    retailer: "Retailer Code",
    "key-accounts": "Key Accounts Code",
    pro: "PRO Code",
  };

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [typeCode, setTypeCode] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const [dynamicFields, setDynamicFields] = useState([
    { product: "", currency: "", mrp: "", discountedPrice: "", qty: "" },
  ]);
  const allowedFileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  useEffect(() => {
    getProductList();
  }, []);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/product-price`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProductList(res);
        } else {
          setProductList([]);
        }
      })
      .catch((err) => {
        setProductList([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "amount") {
      validatedValue = value.replace(/\D/g, "");
    }
    if (name === "paymentType" && value !== "None of Above") {
      setFormData({
        ...formData,
        customPaymentTerm: "",
      });
    }

    if (
      name === "accountNumber" ||
      name === "ifscCode" ||
      name === "bankName"
    ) {
      setBankVerificationDone(
        value === verifiedBankDetails[name] &&
          formData.accountNumber === verifiedBankDetails.accountNumber &&
          formData.ifscCode === verifiedBankDetails.ifscCode
      );
      // Clear the error message when the field is modified
      setBankErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();

      bodyFormData.append("createdBy", userProfile?.employeeId);
      bodyFormData.append("deposit_amount", formData.deposit_amount);

      bodyFormData.append("dealership_id", props.rowData.id);
      bodyFormData.append(
        "deposit_return_date",
        moment(formData.return_date).format("YYYY-MM-DD")
      );
      bodyFormData.append("transfer_payment_type", formData.paymentType);

      bodyFormData.append(
        "cash_amount",
        formData.amount ? formData.amount : ""
      );
      bodyFormData.append(
        "bank_name",
        formData.bankName ? formData.bankName : ""
      );

      bodyFormData.append(
        "bank_account_number",
        formData.accountNumber ? formData.accountNumber : ""
      );
      bodyFormData.append(
        "bank_ifsc_code",
        formData.ifscCode ? formData.ifscCode : ""
      );
      bodyFormData.append(
        "bank_branch",
        formData.branch ? formData.branch : ""
      );
      bodyFormData.append(
        "cheque_return_date",
        formData.cheque_date
          ? moment(formData.cheque_date).format("YYYY-MM-DD")
          : ""
      );
      bodyFormData.append(
        "courier_name",
        formData.courierName ? formData.courierName : ""
      );
      bodyFormData.append(
        "courier_address",
        formData.courierAddress ? formData.courierAddress : ""
      );
      bodyFormData.append(
        "courier_docket_no",
        formData.docketNo ? formData.docketNo : ""
      );
      bodyFormData.append("remarks", formData.remark ? formData.remark : "");

      // bodyFormData.append("bank_name", formData.bankName);
      // bodyFormData.append("account_no", formData.accountNumber);
      // bodyFormData.append("ifsc_code", formData.ifscCode);
      // bodyFormData.append("terms_conditions", formData.termsAndConditions);
      // bodyFormData.append("userId", userProfile?.employeeId);
      bodyFormData.append("verify_json", bankVerfiyJson);

      // Append images
      // formData.image.forEach((img, index) => {
      //   bodyFormData.append(`document[${index}]`, img);
      // });

      formData.image.forEach((img, index) => {
        if (typeof img === "string") {
          bodyFormData.append(`availableImg[${index}]`, img);
        } else {
          if (!img.isDeleted) {
            bodyFormData.append(`document[${index}]`, img);
          }
          // bodyFormData.append(`availableImg[0]`, "");
        }
      });

      const stringImageCount = formData.image.filter(
        (img) => typeof img === "string"
      ).length;

      if (stringImageCount === 0) {
        bodyFormData.append("availableImg[0]", "");
      }
      // bodyFormData.append("availableImg", JSON.stringify(availableImages));

      // Send the request using your preferred method (fetch, axios, etc.)
      utils
        .callAPI("post", "/sales/channel_partner_close", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const fetchPinCodeDetails = async (pinCode) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pinCode}`
      );
      const data = await response.json();
      if (data && data.length > 0 && data[0].Status === "Success") {
        setPinCodeDetails(data[0].PostOffice[0]);
      } else {
        setPinCodeDetails(null);
      }
    } catch (error) {
      setPinCodeDetails(null);
    }
  };

  useEffect(() => {
    if (formData.pinCode?.length === 6) {
      fetchPinCodeDetails(formData.pinCode);
    } else {
      setPinCodeDetails(null);
    }
  }, [formData.pinCode]);

  useEffect(() => {
    if (pinCodeDetails) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: pinCodeDetails.District,
        state: pinCodeDetails.State,
        country: pinCodeDetails.Country,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: "",
        state: "",
        country: "",
      }));
    }
  }, [pinCodeDetails]);

  useEffect(() => {
    if (formData.accountNumber || formData.ifscCode !== "")
      setBankVerificationDone(
        formData.accountNumber === verifiedBankDetails.accountNumber &&
          formData.ifscCode === verifiedBankDetails.ifscCode
      );
  }, [verifiedBankDetails]);

  // useEffect(() => {
  //   if (props.rowData && Object.keys(props.rowData).length > 0) {
  //     const zonesArray = props?.rowData?.zone.split(",");
  //     const tradesArray = props?.rowData?.trade_type.split(",");
  //     const salesArray = props?.rowData?.assign_sales_persons.split(",");
  //     setisEdit(true);
  //     setVerifiedBankDetails({
  //       accountNumber: props.rowData.account_no || "",
  //       ifscCode: props.rowData.ifsc_code || "",
  //     });
  //     //  setTypeCode(props?.trade_type);

  //     const predefinedPaymentTerms = [
  //       "Advanced Payment",
  //       "07 Days",
  //       "15 Days",
  //       "30 Days",
  //       "45 Days",
  //       "60 Days",
  //       "90 Days",
  //       "None of Above",
  //     ];
  //     const paymentTermsFromProps = props?.rowData?.payment_terms || "";
  //     const isCustomPaymentTerm = !predefinedPaymentTerms.includes(
  //       paymentTermsFromProps
  //     );

  //     setFormData({
  //       companyName: props?.rowData?.companyName || "",
  //       contactPerson: props?.rowData?.contactNo || "",
  //       address: props?.rowData?.company_address || "",
  //       city: props?.rowData?.company_city || "",
  //       district: props?.rowData?.company_district || "",
  //       pinCode: props?.rowData?.company_pincode || "",
  //       state: props?.rowData?.company_state || "",
  //       code: props?.rowData?.code || "",
  //       zones: zonesArray || "",
  //       gstNumber: props?.rowData?.gst_no || "",
  //       authPersonName: props?.rowData?.authorised_person_name || "",
  //       tradeOrNonTrade: tradesArray || [],
  //       designation: props?.rowData?.authorised_designation || "",
  //       deposit_date: new Date(props?.rowData?.joining_date) || "",
  //       mobileNo: props?.rowData?.authorised_contact_no || "",
  //       email: props?.rowData?.authorised_email || "",
  //       paymentType: isCustomPaymentTerm
  //         ? "None of Above"
  //         : paymentTermsFromProps,
  //       customPaymentTerm: isCustomPaymentTerm ? paymentTermsFromProps : "",
  //       creditLimit: props?.rowData?.credit_limit || "",
  //       bankName: props?.rowData?.bank_name || "",
  //       accountNumber: props?.rowData?.account_no || "",
  //       ifscCode: props?.rowData?.ifsc_code || "",
  //       termsAndConditions: props?.rowData?.terms_conditions || "",
  //       image: props.rowData.security_attchment || [],
  //       salesPersons: salesArray || "",
  //     });
  //   } else {
  //     setisEdit(false);
  //   }
  // }, [props.rowData]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      image: [...prevFormData.image, ...validFiles],
    }));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setisValidImage(false);
      return;
    } else {
      setisValidImage(true);
    }
    setFormData({ ...formData, image: [...formData.image, ...validFiles] });
    //setFormData((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleDeleteImage = (index) => {

    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prevFormData) => {
          const updatedImages = [...prevFormData.image];
          if (typeof updatedImages[index] === "object") {
            // Handle File object
            updatedImages.splice(index, 1);
          } else if (typeof updatedImages[index] === "string") {
            // Handle URL string
            updatedImages.splice(index, 1); // Simply remove the URL from the array
          }
          return {
            ...prevFormData,
            image: updatedImages,
          };
        });
      }
    });
  };

  const getBankList = () => {
    utils
      .callAPI("get", `/sales/getbankList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setBanks(res);
        } else {
          setBanks([]);
        }
      })
      .catch((err) => {
        setBanks([]);
      });
  };

  const getSalesPersonList = () => {
    utils
      .callAPI("get", `/sales/getSalesPersonList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setSalesPersons(res);
        } else {
          setSalesPersons([]);
        }
      })
      .catch((err) => {
        setSalesPersons([]);
      });
  };

  const getTypeCode = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("vendor_type", vendorType);
    utils
      .callAPI("post", `/sales/getTypeCode`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setTypeCode(res);
        } else {
          setTypeCode([]);
        }
      })
      .catch((err) => {
        setTypeCode([]);
      });
  };

  useEffect(() => {
    getBankList();
    getSalesPersonList();
    //  getTypeCode();
  }, []);

  const handleZoneMultiSelect = (selectedList, selectedItem) => {
    const zoneIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      zones: zoneIds,
    });
    setIsZonesValid(selectedList?.length > 0);
  };

  const handleZoneRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedZones = formData.zones.filter((id) => id !== removedId);

    setFormData({
      ...formData,
      zones: updatedZones,
    });
    setIsZonesValid(selectedList?.length > 0);
  };

  const handleTradeNonTradeRemove = (selectedList, removedItem) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tradeOrNonTrade: prevFormData.tradeOrNonTrade.filter(
        (item) => item !== removedItem.key
      ),
    }));
    setIsTradeVaild(selectedList?.length > 0);
  };

  const handleTradeNonTradeMultiSelect = (selectedList, selectedItem) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tradeOrNonTrade: [...prevFormData.tradeOrNonTrade, selectedItem.key],
    }));

    setIsTradeVaild(selectedList?.length > 0);
  };

  const handleSalesPersonMultiSelect = (selectedList, selectedItem) => {
    const salesPersonIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      salesPersons: salesPersonIds,
    });
    setIsSalesPersonsValid(selectedList?.length > 0);
  };

  const handleSalesPersonRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedSalesPersons = formData.salesPersons.filter(
      (id) => id !== removedId
    );

    setFormData({
      ...formData,
      salesPersons: updatedSalesPersons,
    });
    setIsSalesPersonsValid(selectedList.length > 0);
  };

  const validateSalesPersons = () => {
    if (formData.salesPersons.length === 0) {
      setIsSalesPersonsValid(false);
      return false;
    }
    setIsSalesPersonsValid(true);
    return true;
  };

  const validateZones = () => {
    if (formData.zones.length === 0) {
      setIsZonesValid(false);
      return false;
    }
    setIsZonesValid(true);
    return true;
  };

  const handleBankVerify = () => {
    var bodyFormData = new FormData();

    let errors = {
      accountNumber: "",
      ifscCode: "",
      bankName: "",
    };
    let hasError = false;

    if (!formData.accountNumber) {
      errors.accountNumber = "Please enter the bank account number.";
      hasError = true;
    }
    if (!formData.ifscCode) {
      errors.ifscCode = "Please enter the IFSC code.";
      hasError = true;
    }
    if (!formData.bankName) {
      errors.bankName = "Please select a bank.";
      hasError = true;
    }

    setBankErrors(errors);

    bodyFormData.append("ifsc_code", formData.ifscCode);
    bodyFormData.append("account_no", formData.accountNumber);

    if (!hasError) {
      setIsLoading(true);
      // Trigger API call for bank verification
      utils
        .callAPI("post", `/sales/bankVerifyApiByAdmin`, bodyFormData)
        .then((res) => {
          // If verification is successful, set bank verification state to true
          if (typeof res !== "undefined") {
            if (res.bank_verify) {
              setVerifiedBankDetails({
                accountNumber: formData.accountNumber,
                ifscCode: formData.ifscCode,
              });
              setBankVerificationDone(true);
              setBankVerfiyJson(res.verify_json);
              setBankVerificationDone(true);
            } else {
              setBankVerfiyJson("");
              setBankVerificationDone(false);
            }
          }
        })
        .catch((err) => {
          // Handle error if verification fails
        })
        .finally(() => {
          setIsLoading(false); // Stop loading regardless of success or failure
        });
    } else {
      // Show toast notification if both fields are not filled
      //toast.error("Please enter both bank account number and IFSC code.");
    }
  };

  const handleCheckboxChange = (e) => {
    setShowBankDetails(e.target.checked);
  };

  // const filteredZones = isEdit
  //   ? formData.zones.filter((zone) =>
  //       props.rowData.zone.split(",").includes(zone)
  //     )
  //   : [];
  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Close ${vendorType}`}</h4> */}
          <h4>{isEdit ? `Edit` : `Close`}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Transfer Payment Type"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="paymentType"
                      value={formData.paymentType}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Payment Type...</option>
                      <option value="Neft/RTGS">Neft / RTGS</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Cash">Cash</option>
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    //label="Date"
                    className="floating-label-fancy"
                  >
                    <DatePicker
                      selected={formData.return_date}
                      onChange={(date) =>
                        setFormData({ ...formData, return_date: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Date"
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Deposit Amount"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Deposit Amount"
                      name="deposit_amount"
                      value={formData.deposit_amount}
                      onChange={handleInputChange}
                      // required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            {formData.paymentType === "Neft/RTGS" ? (
              <>
                <RB.Row>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Name of Bank"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Select
                          name="bankName"
                          value={formData.bankName}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Bank...</option>
                          {banks.map((bank, index) => (
                            <option key={index} value={bank.bankName}>
                              {bank.bankName}
                            </option>
                          ))}
                        </RB.Form.Select>
                        {bankErrors.bankName && (
                          <span className="text-danger">
                            {bankErrors.bankName}
                          </span>
                        )}
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Account Number"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Account Number"
                          name="accountNumber"
                          value={formData.accountNumber}
                          onChange={handleInputChange}
                          required
                        />
                        {bankErrors.accountNumber && (
                          <span className="text-danger">
                            {bankErrors.accountNumber}
                          </span>
                        )}
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="IFSC Code"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter IFSC Code"
                          name="ifscCode"
                          value={formData.ifscCode}
                          onChange={handleInputChange}
                          required
                        />
                        {bankErrors.ifscCode && (
                          <span className="text-danger">
                            {bankErrors.ifscCode}
                          </span>
                        )}
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Bank Branch"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Bank Branch"
                          name="branch"
                          value={formData.branch}
                          onChange={handleInputChange}
                          required
                        />
                        {/* {bankErrors.accountNumber && (
                        <span className="text-danger">
                          {bankErrors.accountNumber}
                        </span>
                      )} */}
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  {/* {!bankVerificationDone && (
                    <RB.Col md={4} className="mt-3">
                      <RB.Button onClick={handleBankVerify}>
                        Bank-Verify
                      </RB.Button>
                    </RB.Col>
                  )} */}
                </RB.Row>
              </>
            ) : formData.paymentType === "Cheque" ? (
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mb-3 mt-3">
                    <RB.FloatingLabel
                      //label="Return Date"
                      className="floating-label-fancy"
                    >
                      <DatePicker
                        selected={formData.cheque_date}
                        onChange={(date) =>
                          setFormData({ ...formData, cheque_date: date })
                        }
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Cheque Return Date"
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Row>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Courier Name"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Courier Name"
                          name="courierName"
                          value={formData.courierName}
                          onChange={handleInputChange}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Docket No"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Docket No"
                          name="docketNo"
                          value={formData.docketNo}
                          onChange={handleInputChange}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="CourierAddress"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter Courier Address"
                        name="courierAddress"
                        value={formData.courierAddress}
                        onChange={handleInputChange}
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Row>

                <RB.Col md={12}>
                  <h6 className="mb-1 small">Security Cheque</h6>
                  <hr />
                  <RB.Row className="mt-3 g-3 mb-3">
                    {formData.image.map((file, index) => {
                      const isString = typeof file === "string";
                      const fileUrl = isString
                        ? file
                        : URL.createObjectURL(file);
                      const fileName = isString ? file : file.name;

                      // Check file extension
                      const extension = fileName.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png"].includes(
                        extension
                      );

                      return (
                        <RB.Col className="col-md-6 col-lg-4" key={index}>
                          <div className="position-relative mb-4">
                            <div className="document-image text-center">
                              {isImage ? (
                                <img
                                  src={fileUrl}
                                  alt={`Attachment ${index + 1}`}
                                  className="img-fluid"
                                  style={{
                                    maxHeight: "200px",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div
                                    style={{
                                      padding: "20px",
                                      border: "1px dashed #ccc",
                                      borderRadius: "8px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    <i
                                      className="material-icons-outlined"
                                      style={{ fontSize: "36px" }}
                                    >
                                      description
                                    </i>
                                    <div className="mt-2 small">
                                      📎 {extension.toUpperCase()} File
                                    </div>
                                  </div>
                                </a>
                              )}
                            </div>
                            <RB.Button
                              variant="danger"
                              className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                              onClick={() => handleDeleteImage(index)}
                            >
                              <i className="material-icons-outlined">delete</i>
                            </RB.Button>
                          </div>
                        </RB.Col>
                      );
                    })}

                    <RB.Col className="col-md-6 col-lg-4">
                      <div
                        className={`border p-4 text-center d-flex flex-column align-items-center ${
                          isDraggingOver ? "bg-info" : ""
                        }`}
                        onDragOver={(e) => handleDragOver(e, "image")}
                        onDragEnter={(e) => handleDragEnter(e, "image")}
                        onDragLeave={(e) => handleDragLeave(e, "image")}
                        onDrop={(e) => handleDrop(e, "image")}
                      >
                        <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                          <i className="material-icons-outlined">
                            cloud_upload
                          </i>
                        </div>
                        <p className="mb-0">Drag & Drop your images here</p>
                        <small className="mb-2">or</small>
                        <div>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                            id="securityChequeInput"
                          />
                          <RB.Button
                            variant="primary"
                            className="me-2"
                            onClick={() =>
                              document
                                .getElementById("securityChequeInput")
                                .click()
                            }
                          >
                            <i className="las la-file-upload me-1"></i>Browse
                            Images
                          </RB.Button>
                        </div>
                      </div>
                      <span className={`${isValidImage ? "text-danger" : ""}`}>
                        <small>
                          *Note: Only JPG, JPEG, PNG, PDF, Word, and Excel files
                          are allowed
                        </small>
                      </span>
                    </RB.Col>
                  </RB.Row>
                </RB.Col>
              </RB.Row>
            ) : formData.paymentType === "Cash" ? (
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Amount"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Amount"
                      name="amount"
                      value={formData.amount}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            ) : (
              ""
            )}
            <RB.Row>
              <RB.Col md={12} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Remark"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter Remark"
                      name="remark"
                      value={formData.remark}
                      onChange={handleInputChange}
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button
                  variant="primary"
                  type="submit"
                  // disabled={!bankVerificationDone}
                >
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Close;
